export function getDefaultRenewalDate() {
	let today = new Date();
	let nextYear = new Date(today);
	nextYear.setFullYear(today.getFullYear() + 1);
	return nextYear;
}
